import useWalletUnit from '~/client/hooks/currency/useWalletUnit';
import Img from '~/client/shared/images/Img';
import getCdnIcon from '~/shared/cdn/getCdnIcon';
import IconUsdt from './IconUsdt';

const currenciesWithIcons = [
  'EUR',
  'JPY',
  'mBTC',
  'uBTC',
  'SOC',
  'ETH',
  'LTC',
  'TRX',
  'XRP',
  'USDT',
  'ADA',
];

type Props = { currency?: string };

const CurrencyIcon: FC<Props> = ({ currency }) => {
  const walletUnit = useWalletUnit();

  if (!currenciesWithIcons.includes(currency ?? walletUnit)) {
    return null;
  }

  switch (currency ?? walletUnit) {
    case 'mBTC':
    case 'uBTC':
      return <Img src={getCdnIcon('bitcoin')} width={32} height={32} />;
    case 'USDT':
      return <IconUsdt className="text-bulma rem:text-[28px]" />;
    default:
      return (
        <Img
          src={getCdnIcon(`currencies/${currency ?? walletUnit}`)}
          width={28}
          height={28}
        />
      );
  }
};

export default CurrencyIcon;
